import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  onboardingContainer: {
    padding: theme.spacing.xl,
    maxWidth: 1200,
    margin: "0 auto",
    backgroundColor:
      theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
    minHeight: "100vh",
    [theme.fn.smallerThan("sm")]: {
      padding: theme.spacing.md,
    },
  },
  heading: {
    fontSize: theme.fontSizes.xxl,
    fontWeight: 700,
    marginBottom: theme.spacing.xl,
    color: theme.colorScheme === "dark" ? theme.white : theme.colors.gray[9],
    [theme.fn.smallerThan("sm")]: {
      fontSize: theme.fontSizes.xl,
      textAlign: "left",
    },
  },
  filters: {
    display: "flex",
    gap: theme.spacing.lg,
    marginBottom: theme.spacing.xl,
    flexWrap: "wrap",
    alignItems: "flex-end",
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  filterInput: {
    maxWidth: 300,
    [theme.fn.smallerThan("sm")]: {
      maxWidth: "100%",
    },
  },
  tableWrapper: {
    maxHeight: 500, // Limit table height for scrolling
    overflowY: "auto", // Enable vertical scrolling
    borderRadius: theme.radius.sm,
    [theme.fn.smallerThan("sm")]: {
      maxHeight: 400, // Smaller height on mobile
    },
  },
  table: {
    backgroundColor:
      theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
    borderRadius: theme.radius.sm,
    overflow: "hidden",
    boxShadow: theme.shadows.xs,
  },
  tableHeader: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor:
      theme.colorScheme === "dark"
        ? theme.colors.dark[5]
        : theme.colors.gray[0],
    "& th": {
      padding: theme.spacing.md,
      fontSize: theme.fontSizes.sm,
      fontWeight: 600,
      color:
        theme.colorScheme === "dark"
          ? theme.colors.gray[3]
          : theme.colors.gray[7],
    },
  },
  tableRow: {
    "&:hover": {
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[5]
          : theme.colors.gray[0],
      transition: "background-color 0.2s ease",
    },
    "& td": {
      padding: theme.spacing.md,
      fontSize: theme.fontSizes.sm,
      color:
        theme.colorScheme === "dark"
          ? theme.colors.gray[2]
          : theme.colors.gray[8],
    },
  },
  actionCell: {
    textAlign: "center", // Center buttons for consistency
    minWidth: 120, // Ensure enough space for buttons
  },
  button: {
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: theme.shadows.xs,
    },
    "&:focus": {
      outline: `2px solid ${theme.colors.blue[4]}`,
      outlineOffset: 2,
    },
  },
  pagination: {
    marginTop: theme.spacing.xl,
    justifyContent: "center",
    "& .mantine-Pagination-item": {
      fontSize: theme.fontSizes.sm,
      borderRadius: theme.radius.sm,
      "&:hover": {
        backgroundColor:
          theme.colorScheme === "dark"
            ? theme.colors.dark[4]
            : theme.colors.gray[1],
      },
      "&[data-active]": {
        backgroundColor: theme.colors.blue[6],
        color: theme.white,
      },
    },
  },
}));
